export const SET_STATES = "STATES/SET_STATES";
export const SET_STATE = "STATES/SET_STATE";
export const SET_PAGINATION = "STATES/SET_PAGINATION";
